import { notifications } from "@mantine/notifications";
import { buildTimestampParam, formatTimestamp } from "@/core/timestamp";

const SITE = "https://hittapodd.se";

/** Link to an episode that starts at the given second */
export const momentUrl = (podcast: Pick<Podcast, "slug">, episode: Pick<Episode, "slug">, seconds: number) =>
    `${SITE}/podd/${podcast.slug}/${episode.slug}?t=${buildTimestampParam(seconds)}`;

type ShareEpisode = Pick<Episode, "slug" | "title">;
type SharePodcast = Pick<Podcast, "slug" | "name">;

/** Share a moment with the native share sheet, or copy the link when there is none. */
export const shareMoment = async (podcast: SharePodcast, episode: ShareEpisode, seconds: number) => {
    const url = momentUrl(podcast, episode, seconds);
    const at = formatTimestamp(seconds);

    if (typeof navigator.share === "function") {
        try {
            await navigator.share({
                url,
                title: `${episode.title} - ${podcast.name}`,
                text: `Lyssna på ${episode.title} från ${at}`,
            });
        } catch (error) {
            // Closing the share sheet is not an error
            if (!(error instanceof DOMException && error.name === "AbortError")) {
                console.error("Could not share the link", error);
            }
        }
        return;
    }

    try {
        await navigator.clipboard.writeText(url);
        notifications.show({ message: `Länken till ${at} är kopierad`, color: "teal" });
    } catch (error) {
        console.error("Could not copy the link", error);
        notifications.show({ message: "Det gick inte att kopiera länken", color: "red" });
    }
};
